import type { Chat, ChatTopicBase, LastMessage, Message } from './types/Chat.ts'
import type { UserId } from './types/ids.ts'
import { sortByCreatedAtDesc } from './utils.ts'

export function getLastMessages(chat: Chat): LastMessage[] {
    return Object.values(chat.lastMessages || {}).sort(sortByCreatedAtDesc)
}

export function getLastMessagesForUser(chat: Chat, exceptUserId: UserId): LastMessage[] {
    return Object.values(chat.lastMessages || {})
        .filter((message) => message.createdById !== exceptUserId)
        .sort(sortByCreatedAtDesc)
}

export function getLatestMessage(chat: Chat): Message | undefined {
    return getLastMessages(chat)[0]
}

export function hasNewMessagesForUser(chat: Chat, userId: UserId): boolean {
    return getLastMessagesForUser(chat, userId).filter((message) => !message.seenByAt?.[userId]).length > 0
}

export function getLastMessageForUser(chat: Chat, userId: UserId): Message | undefined {
    return getLastMessagesForUser(chat, userId)[0]
}

export function getTopicKey(base: ChatTopicBase, id?: string): string {
    return [base, id].filter(Boolean).join('-')
}

export function parseTopicKey(topic: string): {
    objectName: ChatTopicBase
    objectId: string
} {
    const [objectName = '', objectId = ''] = (topic || '').split('-')

    return {
        objectName: objectName as ChatTopicBase,
        objectId
    }
}
